module.exports = __webpack_public_path__ + "img/Réalisation portail..183abc22.jpg";